import React from 'react'
import PropTypes from 'prop-types'
import screenType from 'component/menuMission/screenType'
import DownloadSVG from 'component/svgComponents/download'
import FilterIconSVG from 'component/svgComponents/filter'
import Button from 'component/Button/index'

const Options = ({
  setOpenEditModal = () => {},
  setSideFilterVisible = () => {},
  onExport = () => {},
  translate = () => {},
}) => (
  <div className='float-right margin-top'>
    <Button
      className='btn btn-primary margin-right'
      text={translate('missionMenu.options.newProfile')}
      onClick={() =>
        setOpenEditModal({ type: screenType.CREATE_PERSONAL_PROFILE_TYPE })
      }
    />
    <Button
      className='btn btn-secondary margin-right'
      text={translate('missionMenu.options.newMission')}
      onClick={() =>
        setOpenEditModal({ type: screenType.CREATE_MISSION_PROFILE_TYPE })
      }
    />
    <Button
      className='btn btn-primary margin-right'
      text={translate('commonReport.download')}
      onClick={onExport}
      svgIcon={true}
      svgComponent={<DownloadSVG className="default-relatory-svg" style={{ verticalAlign: 'bottom' }} fill="#fff" />}
    />
    <Button
      className='btn btn-secondary'
      text={translate('mobile.filter')}
      onClick={setSideFilterVisible}
      svgIcon={true}
      svgComponent={<FilterIconSVG className="margin-default-svg" newDesign={false} />}
    />
  </div>
)

Options.propTypes = {
  setOpenEditModal: PropTypes.func.isRequired,
  setSideFilterVisible: PropTypes.func.isRequired,
  onExport: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
}

export default Options
